import {
  faPlus,
  faTrashAlt,
  faPencil,
  faMusic,
} from '@fortawesome/pro-regular-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { getPostProvider, normalizeProvider } from 'shared/socialProviders';

const getProvider = props => {
  const { accountProvider, hideMetaActions } = props;
  return (
    normalizeProvider(accountProvider) ||
    (hideMetaActions ? 'manual' : 'instagram')
  );
};

const getSocialAction = (provider, handlers, props) => {
  const { isTikTokConnected } = props;
  if (provider === 'instagram') {
    return {
      tooltip: 'New Instagram Post',
      icon: 'add_circle_outline',
      isFreeAction: true,
      onClick: () => handlers.new(props),
      toolbarIcon: faInstagram,
      toolbarClassName: 'btn-create',
      toolbarButtonPriority: 'info',
    };
  }

  if (provider === 'tiktok' && isTikTokConnected) {
    return {
      tooltip: 'Add TikTok Post',
      icon: 'add_circle_outline',
      isFreeAction: true,
      onClick: () => handlers.new(props),
      toolbarIcon: faMusic,
      toolbarClassName: 'btn-create',
      toolbarButtonPriority: 'info',
    };
  }

  return null;
};

const buildActions = (handlers, props) => {
  const provider = getProvider(props);
  const socialAction = getSocialAction(provider, handlers, props);
  const { canConnectTikTok } = props;
  const showTikTokConnection = provider === 'tiktok' && canConnectTikTok;

  return [
    ...(socialAction ? [socialAction] : []),
    ...(showTikTokConnection
      ? [
          {
            tooltip: 'Connect TikTok',
            icon: 'add_circle_outline',
            isFreeAction: true,
            onClick: () => handlers.connectTikTok(props),
            toolbarIcon: faMusic,
            toolbarClassName: 'btn-create',
            toolbarButtonPriority: 'info',
          },
        ]
      : []),
    {
      tooltip: 'New Custom Post',
      icon: 'add_circle_outline',
      isFreeAction: true,
      onClick: () => handlers.newcustom(props),
      toolbarIcon: faPlus,
      toolbarClassName: 'btn-create',
      toolbarButtonPriority: 'primary',
    },
    () => {
      if (handlers.delete && handlers.supportsDelete) {
        return {
          tooltip: 'Delete',
          color: 'danger',
          buttonStyle: 'outline',
          type: 'button',
          icon: faTrashAlt,
          isRowAction: true,
          isSelectedAction: true,
          onClick: (_, item) => {
            // eslint-disable-next-line no-alert
            if (window.confirm('Are you sure you want to delete this item?'))
              handlers.delete(item, props);
          },
          toolbarIcon: faTrashAlt,
          toolbarClassName: 'btn-delete',
          toolbarButtonPriority: 'danger',
        };
      }

      return null;
    },
    item => {
      if (!item || Array.isArray(item) || !item.postId) {
        return null;
      }

      const postProvider = getPostProvider(item, provider);
      const isTikTok = postProvider === 'tiktok';
      if (postProvider !== 'instagram' && !isTikTok) return null;

      return {
        tooltip: isTikTok ? 'TikTok' : 'Instagram',
        color: 'info',
        type: 'button',
        icon: isTikTok ? faMusic : faInstagram,
        buttonStyle: 'outline',
        isRowAction: true,
        onClick: (_, post) => {
          window.open(post.permaLink);
          document.activeElement.blur();
        },
      };
    },
    {
      tooltip: 'Edit',
      color: 'success',
      type: 'button',
      icon: faPencil,
      isRowAction: true,
      onClick: (_, item) => handlers.edit(item, props),
    },
  ];
};

export default (handlers, props) =>
  buildActions(
    {
      openExternal: item => {
        window.open(item.url);
        document.activeElement.blur();
      },
      ...handlers,
    },
    props
  );
